<div class="formborder mt-2">
  <ng-container>
    <div
      class="row m-0 mt-2 h-b w-b justify-content-between align-items-center"
      style="width: 100%"
    >
      <h1 class="fs-12 m-0">Pre Closer Detail:</h1>
    </div>

    <div class="row m-0 mt-3" id="printData">
      <div style="width: 100%; padding-left: 20px; padding-right: 20px">
        <div class="row m-0 mt-3">
          <div class="col-md-3">
            <h6 class="fs-12">Request Status</h6>
            <p
              [ngClass]="{
                'text-danger':
                  PreCloserDetails.Closer_RequestStatus == 'Waiver Rejected',
                'text-success':
                  PreCloserDetails.Closer_RequestStatus == 'Waiver Approved'
              }"
            >
              {{ PreCloserDetails.Closer_RequestStatus }}
            </p>
            <p *ngIf="PreCloserDetails.TotalWaiver_Approved">
              Approved Waiver Amount:<b>
                ₹{{ PreCloserDetails.TotalWaiver_Approved }}</b
              >
            </p>
          </div>

          <div class="col-md-3">
            <h6 class="fs-12">Last Transaction Date</h6>
            <p>{{ PreCloserDetails.lastTrasactionDate }}</p>
          </div>
          <div class="col-md-3">
            <h6 class="fs-12">Pre-Closure Effective Date</h6>
            <div class="datepicker_feild">
              <input
                [matDatepicker]="picker"
                dateConvert
                placeholder="DD/MM/YYYY"
                [(ngModel)]="PreCloserDetails.LoanCloser_EffectiveDate"
                [min]="MinEffectiveDate"
                [max]="PreCloserDetails.NextDueDate"
                name="LoanCloser_EffectiveDate"
                id="LoanCloser_EffectiveDate"
                (dateChange)="onEffectiveDateChange()"
                [disabled]="PreCloserDetails.Closer_RequestStatus != 'Created'"
                class="form-control input-text-css"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
                style="right: 0 !important"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </div>
          </div>
        </div>

        <table style="margin-bottom: 20px">
          <tbody>
            <tr style="background: #120eeb29">
              <td style="border: 1px solid #b5b0b0; padding: 5px">
                <b>Account Head</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>Due</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>Received</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>Waiver</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>Balance</b>
              </td>
            </tr>
            <tr
              *ngFor="let preCloserData of PreCloserMethodList; let i = index"
              style="height: 43px"
            >
              <td style="border: 1px solid #b5b0b0; padding: 5px">
                {{ preCloserData.ChagesHead }}
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                {{ preCloserData.DueAmount }}
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                {{ preCloserData.ReceiveAmount }}
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <input
                  type="text"
                  [(ngModel)]="preCloserData.WaiverAmount"
                  placeholder="amount"
                  name="WaiverAmount{{ i }}"
                  id="WaiverAmount{{ i }}"
                  class="form-control input-text-css"
                  disabled
                  style="width: 90px; margin: 0px auto"
                  (ngModelChange)="onChangeWaiverAmt($event, preCloserData)"
                />
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                {{ preCloserData.Balance }}
              </td>
            </tr>
            <tr
              *ngIf="PreCloserMethodList.length > 0 && totalCalculator"
              style="background: #120eeb29"
            >
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>Total :</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>{{ totalCalculator.totalDueAmount?.toFixed(2) }}</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>{{ totalCalculator.totalReceiveAmount?.toFixed(2) }}</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>{{ totalCalculator.totalWaiverAmount?.toFixed(2) }}</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>{{ totalCalculator.totalBalance?.toFixed(2) }}</b>
              </td>
            </tr>
          </tbody>
        </table>

        <div
          class="row m-0 h-b w-b"
          style="width: 100%"
          *ngIf="LoanChargesRecoverableList"
        >
          <h1 class="fs-12 m-0">Detail Of Loan Charges Recoverable</h1>
        </div>
        <table
          style="margin-bottom: 20px; width: 50%"
          *ngIf="LoanChargesRecoverableList"
        >
          <tbody>
            <tr style="background: #120eeb29">
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>Head</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>Amount</b>
              </td>
            </tr>
            <tr
              *ngFor="
                let LoanCharges of LoanChargesRecoverableList;
                let i = index
              "
              style="height: 43px"
            >
              <td style="border: 1px solid #b5b0b0; padding: 5px">
                {{ LoanCharges.ChagesHead }}
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                {{ LoanCharges.Amount?.toFixed(2) }}
              </td>
            </tr>
            <tr>
              <td style="border: 1px solid #b5b0b0; padding: 5px">
                <b>Total</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>{{ LoanChargesRecoverable.Due_Amount?.toFixed(2) }}</b>
              </td>
            </tr>
            <tr>
              <td style="border: 1px solid #b5b0b0; padding: 5px">
                <b>Received</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>{{ LoanChargesRecoverable.Received_Amount?.toFixed(2) }}</b>
              </td>
            </tr>
            <tr style="background: #120eeb29">
              <td style="border: 1px solid #b5b0b0; padding: 5px">
                <b>Balance</b>
              </td>
              <td
                style="
                  border: 1px solid #b5b0b0;
                  padding: 5px;
                  text-align: center;
                "
              >
                <b>{{ LoanChargesRecoverable_Balance?.toFixed(2) }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>
